import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Device } from "../../Device";

const VisibleFormatter = (props: { device: Device }) => {
  const { t } = useTranslation();

  const value: boolean | null = props.device.visible;

  const label = t(
    `tables.devices.enums.visible.${
      value === null ? "unknown" : value.toString()
    }`
  );

  return (
    <Chip
      variant="filled"
      size="small"
      label={label}
      color={value === null ? "default" : value ? "success" : "error"}
    />
  );
};

export default VisibleFormatter;
